import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { isImpersonating, getImpersonatedOrg } from '../utils/impersonation';
import VerificationGate from './VerificationGate';

const GATED_ROLES = ['worker', 'employer', 'agent'];

export default function ProtectedRoute({ children, allowedRoles }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-lg text-gray-600">Loading...</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles && !allowedRoles.includes(user.role)) {
    // Admin Support Mode bypass: when an admin is impersonating an employer/agent,
    // allow them into the matching dashboard route so they can act on the org's behalf.
    if (user.role === 'admin' && isImpersonating()) {
      const org = getImpersonatedOrg();
      if (org && allowedRoles.includes(org.role)) {
        return children;
      }
    }
    return <Navigate to="/" replace />;
  }

  // Wrap gated roles (worker / employer / agent) in the VerificationGate.
  // Admins are never gated. Admin Support Mode also bypasses the gate so the
  // admin can act on behalf of an org without being blocked.
  if (GATED_ROLES.includes(user.role) && !isImpersonating()) {
    return <VerificationGate user={user}>{children}</VerificationGate>;
  }

  return children;
}